import type { RootState } from '../../../../../configuration/setup/store';
import { getContracts } from '../../../common/termedLevel/redux/termedLevelRenewal.redux';
import type { TermedLevel } from '../../../common/termedLevel/types';
import { PeriodUnit } from '../../../common/termedLevel/types';
import { getCurrentDate } from '../../../common/utils/dateUtil';
import {
    filterRowsByDates,
    filterRowsByHiddenRenewingContractsIfEnabled,
    filterRowsByHidingDeletedAssetsIfEnabled,
} from './contractSearchService';

export const getExpiresThisMonth = (state: RootState) =>
    countContractsExpiringBetween(today(), endOfThisMonth(), state);

export const getExpiresNextMonth = (state: RootState) =>
    countContractsExpiringBetween(startOfNextMonth(), endOfNextMonth(), state);

const countContractsExpiringBetween = (from: Date, to: Date, state: RootState) => {
    const contracts = getContracts(state);
    const renewableContracts = excludeDailyContracts(contracts);
    const renewableWithoutDeletedAssets = filterRowsByHidingDeletedAssetsIfEnabled(state, renewableContracts);
    const renewableWithoutAutoRenewals = filterRowsByHiddenRenewingContractsIfEnabled(
        state,
        renewableWithoutDeletedAssets
    );

    const filtered = filterRowsByDates(renewableWithoutAutoRenewals, toIsoMidnight(from), toIsoMidnight(to));
    return filtered.length;
};

export const today = () => startOfDay(getCurrentDate());

export const endOfThisMonth = () => {
    const endOfThisMonthDate = startOfDay(getCurrentDate());
    endOfThisMonthDate.setMonth(endOfThisMonthDate.getMonth() + 1);
    endOfThisMonthDate.setDate(0);
    return endOfThisMonthDate;
};

export const startOfNextMonth = () => {
    const startOfNextMonthDate = startOfDay(getCurrentDate());
    startOfNextMonthDate.setMonth(startOfNextMonthDate.getMonth() + 1);
    startOfNextMonthDate.setDate(1);
    return startOfNextMonthDate;
};

export const endOfNextMonth = () => {
    const endOfNextMonthDate = startOfDay(getCurrentDate());
    endOfNextMonthDate.setMonth(endOfNextMonthDate.getMonth() + 2);
    endOfNextMonthDate.setDate(0);
    return endOfNextMonthDate;
};

const excludeDailyContracts = (rows: TermedLevel[]) => rows.filter(contract => contract.periodUnit !== PeriodUnit.DAY);

const startOfDay = (date: Date) => {
    date.setHours(0, 0, 0, 0);
    return date;
};

const toIsoMidnight = (date: Date) => startOfDay(new Date(date)).toISOString();
